import { FC } from 'react'
import BaseWarning from './BaseWarning'

const ShowingBurnoutWarning: FC<{ onClose: () => void }> = ({ onClose }) => {
  return (
    <BaseWarning
      onClose={onClose}
      message="A showing preference change you are about to execute will be on all new listings going forward. Any existing listings, including your active listings, will retain the current showing provider."
    />
  )
}

export default ShowingBurnoutWarning
